import script from "./chanping-2.vue?vue&type=script&setup=true&lang=js"
export * from "./chanping-2.vue?vue&type=script&setup=true&lang=js"

import "./chanping-2.vue?vue&type=style&index=0&id=fee2467c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-fee2467c"]])

export default __exports__